import { useMemo, useRef } from 'react';

export const useDebounce = <P extends any[] = []>(fn: (...args: P) => void) => {
  const timeoutRef = useRef<NodeJS.Timeout>();
  const debounce = useMemo(() => {
    return (...args: P) => {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => fn(...args), 500);
    };
  }, [fn]);
  return { debounce };
};

export default useDebounce;
